import React from 'react';
import CommonButton from '../CommonButton';

interface PawShapeCardProps {
  image?: string;
  name: string;
  onClick?: () => void;
}

const PawShapeCard: React.FC<PawShapeCardProps> = ({
  image = '/images/placeholder-service.png',
  name,
  onClick,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if ((e.key === 'Enter' || e.key === ' ') && onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className="
        group
        relative
        flex
        w-full
        cursor-pointer
        flex-col
        items-center
        overflow-hidden
        rounded-[30px]
        p-4
        sm:p-5
        isolate
        transition-all
        duration-500
        ease-[cubic-bezier(0.25,1,0.5,1)]
        focus:outline-none
        focus-visible:ring-2
        focus-visible:ring-mainBrandColor
      "
    >

      {/* Organic / Paw-like Image Shape */}
      <div
        className="
          relative
          aspect-square
          w-full
          max-h-[200px]
          shrink-0
          flex
          items-center
          justify-center
        "
      >

        <div
          className="
            relative
            h-full
            w-full
            overflow-hidden
            border-2
            border-mainBrandColor
            transition-all
            duration-700
            ease-[cubic-bezier(0.34,1.56,0.64,1)]
            rounded-[60%_40%_55%_45%_/_45%_55%_45%_55%]
            group-hover:rounded-[45%_55%_40%_60%_/_60%_40%_60%_40%]
          "
        >

          {/* Background Image */}
          <img
            src={image}
            alt={name}
            loading="lazy"
            className="
              block
              h-full
              w-full
              object-cover
              transition-transform
              duration-700
              ease-out
              scale-100
              rotate-0
              group-hover:scale-110
              group-hover:rotate-2
            "
          />

          {/* Hover Overlay */}
          <div
            className="
              absolute
              inset-0
              flex
              items-end
              justify-center
              pb-4
              bg-black/20
              opacity-0
              pointer-events-none
              transition-opacity
              duration-500
              ease-out
              group-hover:opacity-100
            "
          >
            <div
              className="
                scale-75
                transition-transform
                duration-500
                ease-[cubic-bezier(0.34,1.56,0.64,1)]
                group-hover:scale-100
              "
            >
              <CommonButton
                text="Book Now"
                variant="filled"
                rounded="full"
              />
            </div>
          </div>

        </div>

      </div>

      {/* Service Name */}
      <div
        className="
          z-10
          mt-4
          flex
          w-full
          flex-col
          items-center
          justify-center
          text-center
        "
      >
        <h3
          className="
            m-0
            text-[16px]
            font-bold
            tracking-[-0.3px]
            text-[#2F5E2E]
            capitalize
            transition-colors
            duration-300
          "
        >
          {name}
        </h3>
      </div>

      {/* Background Glass Accent */}
      <div
        aria-hidden="true"
        className="
          pointer-events-none
          absolute
          -bottom-[50px]
          h-[60px]
          w-[140%]
          rounded-full
          bg-slate-50/50
          backdrop-blur-[4px]
          transition-transform
          duration-500
          translate-y-[40px]
          group-hover:-translate-y-[10px]
        "
      />

    </div>
  );
};

export default PawShapeCard;